import React from 'react';
export function Header() {
  return <header className="mb-8" data-id="element-104">
      <div className="flex items-center text-xs text-gray-500 uppercase tracking-wider mb-5" data-id="element-105">
        <span className="text-red-500 font-semibold" data-id="element-106">RELATIONSHIPS</span>
        <span className="mx-2" data-id="element-107">|</span>
        <span data-id="element-108">Published 3 hours ago</span>
      </div>
      <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-6 text-gray-800" data-id="element-109">
        The Invisible Switch in His Brain That Determines If He'll Come Back
        <span className="text-red-600" data-id="element-110"> (And How to Flip It)</span>
      </h1>
      <div className="flex items-center mb-8 border-b border-gray-200 pb-6" data-id="element-111">
        <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Sophia Weston" className="w-14 h-14 rounded-full mr-4 object-cover border-2 border-red-100" data-id="element-112" />
        <div data-id="element-113">
          <h2 className="font-bold text-lg" data-id="element-114">Sophia Weston</h2>
          <p className="text-sm text-gray-600" data-id="element-115">
            Psychologist & Relationship Recovery Specialist
          </p>
        </div>
      </div>
    </header>;
}